import { render } from "./RegisterClient.vue?vue&type=template&id=5b1f4e90"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__